import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import "@fontsource/barlow-condensed"
import "@fontsource/barlow"


import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { transform } from 'framer-motion';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys)

const circular = definePartsStyle({
  control: defineStyle({
    rounded: "full",
    marginRight: "50px",
    width: "40px",
    height: "40px",
    _checked: {
      bg: "#FBBF24",
      color: "#112248",
      borderColor: "#112248",
      fontSize: "20px",
    },
    _hover: {
      bg: "white",
      opacity: "50%"
    },

  })
})

export const checkboxTheme = defineMultiStyleConfig({
  variants: { circular },
})

const theme = extendTheme({
  styles: {
    global: (props) => ({
      'body': {
        // bgGradient: 'linear(to-b, rgb(22, 32, 99), rgb(140, 155, 255))',
        bgColor: "#112248",
        color: 'white',
        fontFamily: "Barlow, Barlow Condensed, sans-serif"
      },

    })
  },
  components: { Checkbox: checkboxTheme }
})



// const theme = extendTheme({
//   fonts: {
//     heading: `'Open Sans', sans-serif`,
//     body: `'Raleway', sans-serif`,
//   },
// })


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  // <ChakraProvider theme={theme}>
  <ChakraProvider fontFamily="Barlow Condensed" theme={theme}>
    <App />
    </ChakraProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
